// extracted by mini-css-extract-plugin
export var accordionItem = "style-module--accordion-item--cbaf9";
export var accordionItem__content = "style-module--accordion-item__content--cbf2e";
export var accordionItem__details = "style-module--accordion-item__details--8cc9a";
export var accordionItem__img = "style-module--accordion-item__img--4ed2e";
export var accordionItem__item = "style-module--accordion-item__item--d11ac";
export var accordionItem__mainHeading = "style-module--accordion-item__main-heading--cc0da";
export var accordionItem__summary = "style-module--accordion-item__summary--f4d37";
export var accordionItem__summary__date = "style-module--accordion-item__summary__date--98240";
export var accordionItem__summary__issue = "style-module--accordion-item__summary__issue--2e6da";
export var faq__summary = "style-module--faq__summary--c278c";